export default {
  picks: {
    title: "Mis Picks",
    actions: {
      selectLocation: "Seleccionar una ubicación",
      importPhoto: "Importar foto",
      takePhoto: "Tomar foto",
      selectOperatorToContinue: "Selecciona un operador para continuar",
      openOn: "Abrir en {{operator}}",
      visit: "Visitar {{operator}}",
    },
    locationGate: {
      title: "Permite que Linemate acceda a tu ubicación para usar Mis Picks",
      subtitle: "Linemate usa tu ubicación para mostrar mercados y ofertas disponibles en tu zona.",
    },
    empty: {
      title: "Todavía no hay picks",
      subtitle: "Toca cualquier tendencia para agregarla, o comparte una foto y nosotros tomaremos los picks por ti.",
    },
    imageImport: {
      title: "Importar picks",
      scanningBetslip: "Escaneando tu boleto...",
      analyzingImage: "Analizando tu imagen...",
      detectingOdds: "Detectando cuotas",
      failed: "No se pudieron importar los picks",
      pleaseTryAgain: "Por favor, inténtalo de nuevo",
      tryAgain: "Intentar de nuevo",
    },
    labels: {
      parlay: "Parlay",
      sgp: "SGP",
      straight: "Simple",
      legParlay: "Parlay de {{count}} selecciones",
      pricingUnavailable: "Precio no disponible",
      continueToOperator: "Continuar con tu operador",
    },
    sections: {
      availableOrAdjusted: "Todos los props disponibles o ajustados",
      missingProps: "Props faltantes",
      unavailableInRegion: "No disponible en tu región",
    },
    warnings: {
      legsNotFound_one: "No se pudo encontrar {{count}} selección",
      legsNotFound_other: "No se pudieron encontrar {{count}} selecciones",
      adjusted_one: "Se ajustó {{count}} selección",
      adjusted_other: "Se ajustaron {{count}} selecciones",
      and: " y ",
      forOperator: " para {{operator}}.",
    },
  },
};